document.addEventListener('DOMContentLoaded', function () {
    const variantSelect = document.querySelector('[name="id"]');
  
    if (!variantSelect || typeof window.variantTitles === 'undefined') return;
  
    variantSelect.addEventListener('change', function () {
      const selectedVariantId = this.value;
      const newTitle = window.variantTitles[selectedVariantId];
      const titleElement = document.getElementById('dynamic-title');
  
      if (titleElement) {
        titleElement.textContent = newTitle && newTitle.trim() !== ""
          ? newTitle
          : window.defaultVariantTitle;
      }
    });
  });